export const PROFILE_BOOTSTRAP_RESULT = Object.freeze({
  resolved: "resolved",
  identityLinkConflict: "identity_link_conflict",
});

const buildFinalUser = ({
  rawUser,
  auth0User,
  preferredLocale,
  resolveLocale,
  initialPreferredLocale,
}) => ({
  ...rawUser,
  auth0Id: auth0User?.sub,
  preferredLocale: resolveLocale(
    rawUser?.preferredLocale || preferredLocale || initialPreferredLocale
  ),
});

export const fetchBootstrappedSessionProfile = async ({
  apiClient,
  accessToken,
  auth0User,
  preferredLocale,
  initialPreferredLocale,
  resolveLocale,
  resolveApiErrorMessage,
  unableToFetchProfileMessage,
  emailAlreadyLinkedMessage,
} = {}) => {
  const resA = await apiClient.get("/users/me", {
    headers: { Authorization: `Bearer ${accessToken}` },
    validateStatus: (status) => status === 200 || status === 410 || (status >= 200 && status < 300),
  });

  if (resA.status === 200) {
    const raw = resA.data?.user || resA.data;
    return {
      kind: PROFILE_BOOTSTRAP_RESULT.resolved,
      user: buildFinalUser({
        rawUser: raw,
        auth0User,
        preferredLocale,
        resolveLocale,
        initialPreferredLocale,
      }),
    };
  }

  if (resA.status === 410 || resA.status === 204) {
    try {
      const resB = await apiClient.get("/users/me", {
        params: { createIfMissing: 1 },
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      const raw = resB.data?.user || resB.data;
      return {
        kind: PROFILE_BOOTSTRAP_RESULT.resolved,
        user: buildFinalUser({
          rawUser: raw,
          auth0User,
          preferredLocale,
          resolveLocale,
          initialPreferredLocale,
        }),
      };
    } catch (errB) {
      const code = errB?.response?.status;
      const message = resolveApiErrorMessage(errB, {
        fallbackKey: "userStore.unableToFetchProfile",
        fallbackMessage: unableToFetchProfileMessage,
      });

      if (code === 409) {
        const payload = errB?.response?.data || {};
        const canLink = payload?.details?.canLinkIdentities === true;
        if (canLink) {
          return {
            kind: PROFILE_BOOTSTRAP_RESULT.identityLinkConflict,
            conflict: {
              canLinkIdentities: true,
              nextAction: payload?.details?.nextAction || "link_identities",
              email: auth0User?.email || payload?.details?.email || "",
              errorCode: payload?.errorCode || payload?.error || "EMAIL_IN_USE",
              message: message || emailAlreadyLinkedMessage,
            },
          };
        }

        throw new Error(message || emailAlreadyLinkedMessage);
      }

      throw errB;
    }
  }

  throw new Error(resA?.data?.message || unableToFetchProfileMessage);
};
